import {erpResourceApi} from "../../../../services/erp-resource-api.service";

export const save = (doc: any, name: any, payload: any) => {
    return async (dispatch: any) => {
        return await
            dispatch(erpResourceApi.endpoints.update.initiate(
                {doc, name, payload},
            ))
    }
}